import PointsHistoryFilter from './PointsHistoryFilter'

export default PointsHistoryFilter
